import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex mb-3 font-bold" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Invoice: ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Transaction ID: ")
const _hoisted_9 = { class: "font-normal" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Items")
], -1)
const _hoisted_11 = { class: "border thumbnail-wrapper" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_14 = { style: {"font-size":"0.75rem"} }
const _hoisted_15 = { class: "mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Catalog Code:", -1)
const _hoisted_17 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Variant:", -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Quantity:", -1)
const _hoisted_21 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Shipping title:", -1)
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, /*#__PURE__*/_toDisplayString(`Tracking number: `), -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["href"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Carrier:", -1)
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  key: 5,
  class: "mt-2"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Design Qty:", -1)
const _hoisted_35 = {
  key: 6,
  class: "mt-2"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Note:", -1)
const _hoisted_37 = {
  key: 7,
  class: "mt-2"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, /*#__PURE__*/_toDisplayString('Custom: '), -1)
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Change history")
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, " Assignment ", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("b", null, "Designer: ", -1)
const _hoisted_44 = { class: "text-blue-600" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("b", null, "Status: ", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("b", null, "Requested at: ", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("b", null, "Updated at: ", -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("b", null, "History notes: ", -1)
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("b", null, "Notes: ", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", {
  style: {"vertical-align":"middle"},
  class: "font-bold"
}, " Approve ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", {
  style: {"vertical-align":"middle"},
  class: "font-bold"
}, " Reject ", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dolly-flatbed" }, null, -1)
const _hoisted_57 = /*#__PURE__*/_createTextVNode("  Send to review ")
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, " Order Information ", -1)
const _hoisted_59 = { class: "flex flex-col" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("b", null, "Order Status: ", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("b", null, "Source: ", -1)
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("b", null, "Address: ", -1)
const _hoisted_64 = { class: "font-bold" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("b", null, "Design Status: ", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, " Service cost ", -1)
const _hoisted_67 = { class: "text-warning" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_69 = { class: "mt-3 flex" }
const _hoisted_70 = { class: "dialog-footer" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_72 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Reject")
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "text-black" }, "$", -1)
const _hoisted_75 = /*#__PURE__*/_createTextVNode("  Get cost from catalog ")
const _hoisted_76 = { class: "dialog-footer" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_78 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" Save")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_copy_document = _resolveComponent("copy-document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_UploadDesign = _resolveComponent("UploadDesign")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ChangeHistoryContent = _resolveComponent("ChangeHistoryContent")!
  const _component_hire_design_status_tag = _resolveComponent("hire-design-status-tag")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    backPageTitle: `Back`,
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      (_ctx.data.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_skeleton, {
                    rows: 12,
                    animated: true
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("span", _hoisted_3, [
                        _createElementVNode("a", {
                          href: "#",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboardOrderName(_ctx.state.order.orderName))),
                          class: "ml-2",
                          title: _ctx.state.order.orderName,
                          style: {"font-size":"1.25rem"}
                        }, _toDisplayString(_ctx.state.order.orderName), 9, _hoisted_4),
                        _createElementVNode("a", {
                          href: "#",
                          class: "ml-3",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyToClipboardOrderName(_ctx.state.order.orderName))),
                          title: "Copy to clipboard"
                        }, [
                          _createVNode(_component_el_icon, { style: {"font-size":"1.05rem"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_copy_document)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (_ctx.state.order?.invoice && _ctx.isManager)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                            _createVNode(_component_el_divider, { direction: "vertical" }),
                            _hoisted_6,
                            (_ctx.state.order?.rejectedInvoiceId)
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 0,
                                  to: { path: `/ag/invoices/${_ctx.state.order.rejectedInvoiceId}` }
                                }, {
                                  default: _withCtx(({ href }) => [
                                    _createVNode(_component_el_link, {
                                      href: href,
                                      type: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.state.order.rejectedInvoiceId), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["href"])
                                  ]),
                                  _: 1
                                }, 8, ["to"]))
                              : (_ctx.state.order?.invoice)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: { path: `/ag/invoices/${_ctx.state.order.invoice}` }
                                  }, {
                                    default: _withCtx(({ href }) => [
                                      _createVNode(_component_el_link, {
                                        href: href,
                                        type: "primary"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.state.order.invoice), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["href"])
                                    ]),
                                    _: 1
                                  }, 8, ["to"]))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.state.order?.transactionId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createVNode(_component_el_divider, { direction: "vertical" }),
                            _hoisted_8,
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.state.order?.transactionId), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 18,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  (!_ctx.data.isLoading)
                    ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                        header: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.order.items.filter(
            (i) => i.sku !== 'Tip'
          ), (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_row, {
                              key: item.sku
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 10,
                                  class: "order-item-artwork"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_11, [
                                      (item.imageSrc)
                                        ? (_openBlock(), _createBlock(_component_UploadImage, {
                                            key: 0,
                                            allowDelete: false,
                                            setData: item,
                                            itemIndex: index,
                                            data: item.imageSrc,
                                            artwork: 'imageSrc',
                                            onCallback: _ctx.callbackImageSrc,
                                            onChangeArtwork: _ctx.changeImageSrc,
                                            class: "border order-artwork-upload",
                                            permission: 
                    _ctx.isEditableDesignByDesigner(
                      _ctx.state.order.status,
                      _ctx.state.order.metadata.hire_design_status
                    )
                      ? 'all'
                      : 'read'
                  
                                          }, null, 8, ["setData", "itemIndex", "data", "onCallback", "onChangeArtwork", "permission"]))
                                        : (_openBlock(), _createBlock(_component_UploadDesign, {
                                            key: 1,
                                            onUploaded: _ctx.changeImageSrc,
                                            artworkName: 'imageSrc',
                                            itemIndex: index,
                                            disableEdit: 
                    !_ctx.isEditableDesignByDesigner(
                      _ctx.state.order.status,
                      _ctx.state.order.metadata.hire_design_status
                    )
                  ,
                                            class: "order-artwork-upload",
                                            style: {"min-height":"200px"}
                                          }, null, 8, ["onUploaded", "itemIndex", "disableEdit"]))
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artworkSpaces, (artwork) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "p-1 order-artwork h-100",
                                        key: artwork
                                      }, [
                                        (item[artwork])
                                          ? (_openBlock(), _createBlock(_component_UploadImage, {
                                              key: 0,
                                              setData: item,
                                              itemIndex: index,
                                              data: item[artwork],
                                              artwork: artwork,
                                              onCallback: _ctx.callbackDesign,
                                              onChangeArtwork: _ctx.changeArtwork,
                                              class: "border order-artwork-upload",
                                              permission: 
                    _ctx.isEditableDesignByDesigner(
                      _ctx.state.order.status,
                      _ctx.state.order.metadata.hire_design_status
                    )
                      ? 'all'
                      : 'read'
                  
                                            }, null, 8, ["setData", "itemIndex", "data", "artwork", "onCallback", "onChangeArtwork", "permission"]))
                                          : (_openBlock(), _createBlock(_component_UploadDesign, {
                                              key: 1,
                                              onUploaded: _ctx.uploaded,
                                              artworkName: artwork,
                                              itemIndex: index,
                                              disableEdit: 
                    !_ctx.isEditableDesignByDesigner(
                      _ctx.state.order.status,
                      _ctx.state.order.metadata.hire_design_status
                    )
                  ,
                                              class: "order-artwork-upload"
                                            }, null, 8, ["onUploaded", "artworkName", "itemIndex", "disableEdit"]))
                                      ]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, {
                                  span: 14,
                                  class: "p-3 order-item-detail",
                                  style: {"border-right":"1px solid rgb(229, 231, 235)"}
                                }, {
                                  default: _withCtx(() => [
                                    (item.productId)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                          _createVNode(_component_router_link, {
                                            to: {
                    name: 's.product-detail',
                    params: { id: item.productId },
                  },
                                            class: "font-bold text-blue-600"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(item.itemName), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["to"])
                                        ]))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(item.itemName), 1)),
                                    _createElementVNode("span", _hoisted_14, [
                                      _createElementVNode("p", _hoisted_15, [
                                        _hoisted_16,
                                        _createTextVNode(" " + _toDisplayString(item.catalogCode), 1)
                                      ]),
                                      (item.variantTitle)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, [
                                            _hoisted_18,
                                            _createTextVNode(" " + _toDisplayString(item.variantTitle), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.quantity)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                            _hoisted_20,
                                            _createTextVNode(" " + _toDisplayString(item.quantity), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.shippingTitle)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                            _hoisted_22,
                                            _createTextVNode(" " + _toDisplayString(item.shippingTitle), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (
                    item.trackingNumber || item?.trackingNumbers?.length > 0
                  )
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                                            _hoisted_24,
                                            (item.trackingNumbers?.length > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.trackingNumbers, (trackingNum, index) => {
                                                    return (_openBlock(), _createElementBlock("span", { key: index }, [
                                                      _createElementVNode("a", {
                                                        href: `https://t.17track.net/en#nums=${trackingNum}`,
                                                        target: "blank",
                                                        class: "text-blue-600"
                                                      }, [
                                                        (index < item.trackingNumbers.length - 1)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(trackingNum + ', '), 1))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(trackingNum), 1))
                                                      ], 8, _hoisted_26)
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.carrier || item?.carriers?.length > 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                            _hoisted_30,
                                            (item.carriers?.length > 0)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(item.carriers.join(', ')), 1))
                                              : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(item.carrier), 1))
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.designQty)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                            _hoisted_34,
                                            _createTextVNode(" " + _toDisplayString(item.designQty), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.note)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                                            _hoisted_36,
                                            _createTextVNode(" " + _toDisplayString(item.note), 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (item.custom)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                                            _hoisted_38,
                                            (item.custom?.map((item) => item?.value)?.[0] != null)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  onClick: ($event: any) => (_ctx.onViewDetailCustom(item.custom)),
                                                  class: "text-blue-600",
                                                  title: "Click to view detail"
                                                }, _toDisplayString(item.custom?.map((item) => item?.value)?.join('; ')), 9, _hoisted_39))
                                              : (_openBlock(), _createElementBlock("a", {
                                                  key: 1,
                                                  onClick: ($event: any) => (_ctx.onViewDetailCustom(item.custom)),
                                                  class: "text-blue-600",
                                                  title: "Click to view detail"
                                                }, " View Detail Custom ", 8, _hoisted_40))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_divider, { direction: "horizontal" })
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.state.order?.changeHistory)
                    ? (_openBlock(), _createBlock(_component_el_card, {
                        key: 1,
                        class: "my-3"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_41
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_ChangeHistoryContent, {
                            userType: "agency",
                            data: _ctx.state.order?.changeHistory
                          }, null, 8, ["data"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  (!_ctx.data.isLoading && _ctx.state.order.metadata)
                    ? (_openBlock(), _createBlock(_component_el_card, {
                        key: 0,
                        class: "my-3"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_42
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _hoisted_43,
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.state.order.metadata.email), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_45,
                              _createVNode(_component_hire_design_status_tag, {
                                hireDesignStatus: _ctx.state.order.metadata.hire_design_status
                              }, null, 8, ["hireDesignStatus"])
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_46,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.state.order.metadata.created_at)), 1)
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_47,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.state.order.metadata.updated_at)), 1)
                            ]),
                            (_ctx.state.order.metadata.items_issues)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                                  _hoisted_49,
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.order.metadata.items_issues, (o, index) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: index,
                                      class: "text-primary"
                                    }, _toDisplayString(index + 1 + '-' + o.itemName), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.order.metadata?.notes)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                                  _hoisted_51,
                                  _createVNode(_component_el_text, {
                                    class: "mx-1",
                                    size: "small",
                                    tag: "sub"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.state.order.metadata.notes), 1)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true),
                            (
                _ctx.state.order.metadata.hire_design_status ===
                  _ctx.HIRE_DESIGN_STATUS.INREVIEW && _ctx.isManager
              )
                              ? (_openBlock(), _createBlock(_component_el_col, {
                                  key: 2,
                                  span: 24,
                                  class: "mt-3",
                                  style: {"text-align":"end"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_popconfirm, {
                                      "confirm-button-text": "Yes",
                                      "cancel-button-text": "No",
                                      "icon-color": "#626AEF",
                                      title: "Are you sure to approve this design?",
                                      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeRequestDesignStatus('approved'))),
                                      width: "20%"
                                    }, {
                                      reference: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                                              default: _withCtx(() => [
                                                _hoisted_52
                                              ]),
                                              _: 1
                                            }),
                                            _hoisted_53
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      size: "small",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onShowRejectModal()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, { style: {"vertical-align":"middle"} }, {
                                          default: _withCtx(() => [
                                            _hoisted_54
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_55
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_col, {
                              span: 24,
                              class: "mt-3",
                              style: {"text-align":"end"}
                            }, {
                              default: _withCtx(() => [
                                (
                  _ctx.isDesigner &&
                  _ctx.validateEditableByDesignStatus(
                    _ctx.state.order.metadata.hire_design_status
                  )
                )
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      size: "small",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onHireDesignCheckedChange()))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_56,
                                        _hoisted_57
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.data.isLoading && _ctx.state.order.metadata)
                    ? (_openBlock(), _createBlock(_component_el_card, {
                        key: 1,
                        class: "my-3"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_58
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_59, [
                            _createElementVNode("p", null, [
                              _hoisted_60,
                              _createVNode(_component_el_tag, {
                                type: _ctx.getOrderStatusColor(_ctx.state.order.status),
                                size: "small",
                                title: "Order status"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.state.order.status), 1)
                                ]),
                                _: 1
                              }, 8, ["type"])
                            ]),
                            _createElementVNode("p", null, [
                              _hoisted_61,
                              _createVNode(_component_el_tag, {
                                type: "info",
                                size: "small",
                                title: "Source"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.state.order.source), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            (!_ctx.state.order)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                                  _createElementVNode("p", null, [
                                    _hoisted_63,
                                    _createVNode(_component_el_tag, {
                                      type: _ctx.getAddressStatusColor(_ctx.state.order?.addressValid),
                                      effect: "dark",
                                      class: "ml-3 rounded",
                                      size: "small",
                                      title: _ctx.addressTitleMap.get(_ctx.state.order?.addressValid)
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.addressTitleMap.get(_ctx.state.order?.addressValid)), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["type", "title"])
                                  ]),
                                  _createElementVNode("p", null, [
                                    _hoisted_65,
                                    _createVNode(_component_el_tag, {
                                      type: _ctx.state.order?.designStatus === 2 ? 'success' : 'error',
                                      size: "small",
                                      title: "Artwork status",
                                      class: "ml-3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.state.order?.designStatus === 2 ? 'Completed' : 'Incomplete'), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["type"])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.data.isLoading && _ctx.state.order.metadata)
                    ? (_openBlock(), _createBlock(_component_el_card, {
                        key: 2,
                        class: "my-3"
                      }, {
                        header: _withCtx(() => [
                          _hoisted_66
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_67, [
                            _createTextVNode(_toDisplayString(_ctx.formatterDollars(_ctx.state.order.designFeeValue)) + " ", 1),
                            (_ctx.isManager)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "text",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onShowDesignServiceCostModal())),
                                  title: "Change catalog code"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_68
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.data.showRejectModal,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data.showRejectModal) = $event)),
        title: "Disapprove comment",
        top: "7vh"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_70, [
            _createVNode(_component_el_button, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.data.showRejectModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_71,
                _hoisted_72
              ]),
              _: 1
            }),
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": "Yes",
              "cancel-button-text": "No",
              "icon-color": "#626AEF",
              title: "Are you sure to reject this design?",
              onConfirm: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeRequestDesignStatus('rejected'))),
              width: "20%"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _hoisted_73
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_table, {
                    data: _ctx.state.order.items,
                    "element-loading-text": "Loading...",
                    lazy: true,
                    onSelectionChange: _ctx.handleCheckedItemsChange,
                    style: {"width":"100%"},
                    stripe: "",
                    "table-layout": "auto"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "40"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Mockup",
                        width: "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_image, {
                            style: {"width":"100px","height":"100px"},
                            fit: "fit",
                            src: _ctx.imageUrl(scope.row.imageSrc, true, 200)
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        property: "itemName",
                        label: "Item name"
                      })
                    ]),
                    _: 1
                  }, 8, ["data", "onSelectionChange"]), [
                    [_directive_loading, _ctx.data.isLoading]
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.state.order.metadata.notes,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.order.metadata.notes) = $event)),
                      placeholder: "Comment",
                      class: "mr-3",
                      type: "textarea"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.data.showEditCostModal,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data.showEditCostModal) = $event)),
        title: "Edit design cost",
        top: "7vh",
        width: "40%"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_el_button, {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.data.showEditCostModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_77,
                _hoisted_78
              ]),
              _: 1
            }),
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": "Yes",
              "cancel-button-text": "No",
              "icon-color": "#626AEF",
              title: "Are you sure to change design service cost?",
              onConfirm: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeDesignCost())),
              width: "20%"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_button, { type: "primary" }, {
                  default: _withCtx(() => [
                    _hoisted_79
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Design service cost",
                    class: "font-bold",
                    prop: "designFeeValue"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.state.order.designFeeValue,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.order.designFeeValue) = $event)),
                        autocomplete: "off",
                        type: "number"
                      }, {
                        prefix: _withCtx(() => [
                          _hoisted_74,
                          _createVNode(_component_el_button, { type: "primary" }, {
                            default: _withCtx(() => [
                              _hoisted_75
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CustomDialog, { ref: "customDialog" }, null, 512)
    ]),
    _: 1
  }, 16))
}